export enum PayoutRequestStatusEnum {
  WAITING = "w",
  SENT = "s",
  CANCELLED = "c",
  PAID = "p",
  REJECTED = "x",
}

export type PayoutRequestStatusTypes = `${PayoutRequestStatusEnum}`;

export enum PayoutAccountTypeEnum {
  PIX = "pix",
  BANK = "bank",
  WALLET = "wallet",
  OTHER = "other",
}

export type PayoutAccountTypeTypes = `${PayoutAccountTypeEnum}`;

export enum PayoutMethodIdEnum {
  PIX = 1,
}

export interface IPayoutOptionDTO<T = string | number> {
  type: T;
  text: string;
  title: string;
  color: string;
}

export interface IPayoutRequestDTO {
  id: number;
  payoutMethod: PayoutMethodIdEnum;
  payoutMethodName: string;
  account: {
    id: number;
    type: PayoutAccountTypeTypes;
    label?: string;
    holderName?: string;
    accountKey: string;
    bankName?: string;
  };
  value: number;
  internalFee: number;
  externalFee: number;
  status: PayoutRequestStatusTypes;
  dateRequest: string;
  dateClose?: string | null;
  note?: string | null;
}

export interface ICustomerBalanceDTO {
  available: number;
  pendingRelease: number;
  total: number;
}

export interface IPayoutAccountOptionDTO {
  id: number;
  payoutMethod: PayoutMethodIdEnum;
  payoutMethodName: string;
  type: PayoutAccountTypeTypes;
  label?: string;
  holderName?: string;
  accountKey: string;
  bankName?: string;
  status?: "a" | "i" | "x";
}

export type PayoutFeeType = "percent" | "flat" | "default";

export interface IPayoutMethodFeeRangeDTO {
  value: number | null;
  minAmount: number;
  maxAmount: number;
}

export interface IPayoutMethodFeeDTO {
  type: PayoutFeeType;
  table: IPayoutMethodFeeRangeDTO[];
}

export interface IPayoutMethodConfigDTO {
  config?: {
    withdraw?: {
      min?: number;
      max?: number;
    };
  };
  fees?: {
    internal?: IPayoutMethodFeeDTO;
    external?: IPayoutMethodFeeDTO;
  };
}

export type IPayoutMethodsConfigDTO = Record<string, IPayoutMethodConfigDTO>;
